<template>
    <div>
        <div>
            <br><br>
            <h3>{{ $t("posts.vehicleDescription") }}</h3>
            <el-row :gutter="20" class="surligneTitre">
                <el-col :span="6" v-if="post.millesime">{{$labels.millesime}} :</el-col>
                <el-col :span="6" v-if="post.millesime">{{post.millesime}}</el-col>

                <el-col :span="6" v-if="post.puissance_reelle">{{$labels.puissance_reelle}} :</el-col>
                <el-col :span="6" v-if="post.puissance_reelle">{{post.puissance_reelle}} ch</el-col>

                <el-col :span="6" v-if="post.mise_en_circulation">{{$labels.mise_en_circulation}} :</el-col>
                <el-col :span="6" v-if="post.mise_en_circulation">{{post.mise_en_circulation}}</el-col>

                <el-col :span="6" v-if="post.puissance_fiscale">{{$labels.puissance_fiscale}} :</el-col>
                <el-col :span="6" v-if="post.puissance_fiscale">{{post.puissance_fiscale}} ch</el-col>

                <el-col :span="6" v-if="post.kilometrage">{{$labels.kilometrage}} :</el-col>
                <el-col :span="6" v-if="post.kilometrage">{{post.kilometrage}} km</el-col>

                <el-col :span="6" v-if="post.garantie_libelle">{{$labels.garantie_libelle}} :</el-col>
                <el-col :span="6" v-if="post.garantie_libelle">{{post.garantie_libelle}}</el-col>

                <el-col :span="6" v-if="post.nb_portes">{{$labels.nb_portes}} :</el-col>
                <el-col :span="6" v-if="post.nb_portes">{{post.nb_portes}}</el-col>

                <el-col :span="6" v-if="post.garantie">{{$labels.garantie}} :</el-col>
                <el-col :span="6" v-if="post.garantie">{{post.garantie}} {{$t('general.month')}}</el-col>

                <el-col :span="6" v-if="post.couleur">{{$labels.couleur}} :</el-col>
                <el-col :span="6" v-if="post.couleur">{{post.couleur}} {{post.couleur_precision}}</el-col>

                <el-col :span="6" v-if="post.premiere_main">{{$labels.premiere_main}} :</el-col>
                <el-col :span="6" v-if="post.premiere_main">{{displayBoolean(post.premiere_main)}}</el-col>

                <el-col :span="6" v-if="post.boite_de_vitesse">{{$labels.boite_de_vitesse}} :</el-col>
                <el-col :span="6" v-if="post.boite_de_vitesse">{{post.boite_de_vitesse}}</el-col>

                <el-col :span="6" v-if="post.energie">{{$labels.energie}} :</el-col>
                <el-col :span="6" v-if="post.energie">{{post.energie}}</el-col>

                <el-col :span="6" v-if="post.poids">{{$labels.poids}} :</el-col>
                <el-col :span="6" v-if="post.poids">{{post.poids}} kg</el-col>
            </el-row>
            <br><br>

        </div>
        <!--FIN Description du véhicule-->

        <div v-if="post.equipments">
            <h3>{{ $t("posts.edit.tabEquipments") }}</h3>
            <el-row :gutter="20"  class="surligneTitre">
                <el-col>{{post.equipments}}</el-col>
            </el-row>
            <br><br>
        </div>

        <div v-if="post.equipements_non_qualifies">
            <h3>{{ $t("posts.edit.otherInformation") }}</h3>
            <el-row :gutter="20"  class="surligneTitre">
                <el-col>
              <span v-html="post.equipements_non_qualifies" style="white-space: pre-wrap;">
                    </span>
                </el-col>
            </el-row>
            <br>
        </div>

        <!--DEBUT Condition de vente-->
        <div class="grid-content bg-purple text-center surligneTitre" id="blockPrix">
          <div v-if="post.financement_mensualites">
            <strong v-if="post.devise_iso_4217 === 'EUR'">{{ post.financement_apport }} € + {{ post.financement_mensualites }} € / {{ $t('general.month') }}</strong>
            <strong v-else>{{ post.financement_apport }} {{post.devise_iso_4217}} + {{ post.financement_mensualites }} {{post.devise_iso_4217}} / {{ $t('general.month') }}</strong>
          </div>
          <div v-else>
            <strong v-if="post.devise_iso_4217 === 'EUR'">{{ post.prix }} €</strong>
            <strong v-else>{{ $t("posts.view.saleConditionsPriceVo", { price: post.prix}) }} {{post.devise_iso_4217}}</strong>
          </div>
        </div>
        <!--FIN Condition de vente-->
    </div>
</template>

<script>
import UbiPanel from '../../../components/Panel'
import ElButton from '../../../components/Button'
import { mapState } from 'vuex'

export default {
  name: 'PostViewImmo',
  components: { ElButton, UbiPanel },
  inject: ['browserContext'],
  props: ['post'],
  data () {
    return {
      photoAgrandit: null,
      photoPrincipale: null,
      showModal: false,
      emailDestinataire: null,
      commentaireEmail: this.$t('posts.view.sendByEmailComment')
    }
  },
  computed: {
    ...mapState('posts', ['filter']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    saisit_en_ligne () {
      return this.sitimmoUser.saisit_annonces_en_ligne === true
    }

  },
  methods: {
    displayBoolean (value) {
      if (value === true || value === 'oui') {
        return this.$t('general.yes')
      } else if (value === false || value === 'non') {
        return this.$t('general.no')
      }

      return null
    }
  }
}
</script>

<style>
    .surligneTitre{
        border-top:solid;
        border-color: #00b4cc;
        border-width: 1px;
    }

    #blockPrix {
        border: solid;
        border-color: #00b4cc;
        border-width: 1px;
        font-size: 30px;
    }

    /*DEBUT VERSION MOBILE*/
    @media screen and (max-width: 780px) {
        .blockDonnees {
            display: inline-block;
            width: 50%;
        }

        .blockDonneesDPE {
            display: inline-block;
            width: 70%;
        }

        .blockDonneesDPEVal {
            display: inline-block;
            width: 30%;
        }

        .block {
            width: 45%;
            display: inline-block;
            margin-left: 2%;
        }
    }

    /*FIN VERSION MOBILE*/

    /*DEBUT POPUP ENVOYER ANNONCE*/
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 600px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /*FIN POPUP ENVOYER ANNONCE*/
</style>
